module.exports = __webpack_public_path__ + "media/images/zp_title-2805f69d11d18dbb669af50485f9d057.png";